export class StreamClosedSuccessfully extends Error {
  constructor() {
    super("Stream closed successfully");
  }
}
